import Tasks from 'APP/Tasks';

import { GroupsEvent } from '../GroupsEvent';

export class GroupChanged extends GroupsEvent {
  process() {
    Tasks.group.loadGroupsByIds([this.eventPayload.groupId]);
  }
}
